export enum RegisterRoutes {
  root = 'register',
  multiorg = 'multiorg',
}
